var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBoy = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "M_T_D_Icon_Gender",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-boy{fill:#9bbeff}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_362",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#dee9ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Boy",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    d: "M76.114 302.58a.806.806 0 0 0-.806.806v.943a.806.806 0 1 0 1.612 0v-.943a.806.806 0 0 0-.806-.806z",
    className: "cls-boy",
    transform: "translate(-69.273 -291.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    d: "M155.771 304.33v-.943a.806.806 0 1 0-1.612 0v.943a.806.806 0 1 0 1.612 0z",
    className: "cls-boy",
    transform: "translate(-141.806 -291.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    d: "M18.949 173.937a9.344 9.344 0 0 0 .382-2.743 7.889 7.889 0 0 0-2.855-6.124 10.121 10.121 0 0 0-6.564-2.149 10.128 10.128 0 0 0-6.489 2.232 7.794 7.794 0 0 0-2.754 6.132 9.341 9.341 0 0 0 .383 2.651 2.845 2.845 0 0 0 2.483 4.969 8.177 8.177 0 0 0 1.593 1.578 8.147 8.147 0 0 0 9.743 0 8.178 8.178 0 0 0 1.594-1.579 2.845 2.845 0 0 0 2.484-4.968zm-14.487-7.562a8.53 8.53 0 0 1 5.465-1.85h.1a8.5 8.5 0 0 1 5.43 1.782 6.229 6.229 0 0 1 2.273 4.9 7.717 7.717 0 0 1-.479 2.764q-.051-.072-.106-.143a3.2 3.2 0 0 0-1.964-1.181 4.915 4.915 0 0 1-2-3.561.8.8 0 1 0-1.6 0 5.484 5.484 0 0 0 .941 3.009 12.152 12.152 0 0 1-3.89-2.1l-2.047-1.754a.8.8 0 1 0-1.043 1.218l.39.334a6.877 6.877 0 0 0-1.191.738 6.346 6.346 0 0 0-2.141 2.99 7.737 7.737 0 0 1-.328-2.236 6.235 6.235 0 0 1 2.19-4.91zM1.6 176.143a1.241 1.241 0 0 1 .124-.54 9.359 9.359 0 0 0 .535.9 8.01 8.01 0 0 0 .341.863 1.245 1.245 0 0 1-1-1.223zm12.312 3.057a6.543 6.543 0 0 1-7.824 0 6.6 6.6 0 0 1-2.295-3.178 5.041 5.041 0 0 1 3.493-5.055l.3.26.019.016a13.75 13.75 0 0 0 7.168 2.967 1.622 1.622 0 0 1 1.443 1.77 6.594 6.594 0 0 1-2.304 3.22zm3.485-1.837a8 8 0 0 0 .34-.862 9.339 9.339 0 0 0 .536-.9 1.242 1.242 0 0 1-.876 1.758z",
    className: "cls-boy",
    transform: "translate(0 -162.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    d: "M100.322 344.909a1.721 1.721 0 0 1-2.43 0 .6.6 0 1 0-.855.855 2.93 2.93 0 0 0 4.14 0 .6.6 0 1 0-.855-.855z",
    className: "cls-boy",
    transform: "translate(-89.107 -330.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    d: "M63.24 336.662h-.627a.6.6 0 0 0 0 1.209h.627a.6.6 0 1 0 0-1.209z",
    className: "cls-boy",
    transform: "translate(-57.04 -322.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    d: "M165.91 336.662h-.627a.6.6 0 1 0 0 1.209h.627a.6.6 0 1 0 0-1.209z",
    className: "cls-boy",
    transform: "translate(-151.483 -322.738)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBoy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-boy.04ea2719.svg";
export { ForwardRef as ReactComponent };